import React from 'react'
import Footer from '../Components/Footer/Footer'
import LoginTopBar from '../Components/LoginTopBar/LoginTopBar'
import RegisterCustomer from '../Components/RegisterCustomer/RegisterCustomer'

const RegisterPage = () => {
  return (
    <>
    <LoginTopBar/>
    <RegisterCustomer/>
    {/* <Footer/> */}
    </>
  )
}

export default RegisterPage